import React from "react";
import GenericAdminCRUD from "../components/GenericAdminCRUD";

export default function ClientCampaignsEditor() {
  return (
    <GenericAdminCRUD
      title="Campanhas por Produto"
      subtitle="Cada produto imobiliário pode ter várias campanhas (lançamento, sustentação, remarketing…)."
      path="client-campaigns"
      fields={[
        { key: "client_id", label: "Cliente *", type: "clientSelect" },
        { key: "product_id", label: "Produto *", type: "productSelect" },
        { key: "name", label: "Nome da Campanha *", type: "text" },
        { key: "period", label: "Período (ex: Jan/2025 - Jun/2025)", type: "text" },
        { key: "status", label: "Status", type: "select", options: [
          { value: "planejamento", label: "Em planejamento" },
          { value: "ativa", label: "Ativa" },
          { value: "encerrada", label: "Encerrada" },
        ]},
        { key: "description", label: "Descrição", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "name", label: "Campanha" },
        { key: "product_id", label: "Produto", render: (it, { products }) => products.find((p) => p.id === it.product_id)?.name || "—" },
        { key: "period", label: "Período" },
        { key: "status", label: "Status" },
      ]}
    />
  );
}
